

<script>
export default {
	name: "ReportTable",
	props: ["emptyText", "fields", "totals", "totalsClass", "content"],
	data() {
		return {};
	},

	created() {},

	destroyed() {},

	render(h) {
		let totalsHead = _.cloneDeep(this.totals);
		let totalsFoot = _.cloneDeep(this.totals);

		totalsHead.forceHead = true;
		totalsHead.hl = true;
		totalsFoot.forceFoot = true;
		totalsFoot.hl = true;

		let items = [];
		if (this.content && this.content.length > 0) {
			items = items.concat(totalsHead);
			items = items.concat(this.content);
			items = items.concat(totalsFoot);
		}

		let processedFields = [];
		_.each(this.fields, field => {
			let nf = {};
			_.each(field, (v, k) => {
				if (k == "tdClass") {
					nf.tdClass = (value, key, row) => {
						let classes = field.tdClass;
						if (row.hl) {
							classes = classes + " " + this.totalsClass;
						}
						return classes;
					};
				} else {
					nf[k] = v;
				}
			});
			processedFields.push(nf);
		});

		return (
			<b-table
				striped
				hover
				showEmpty={true}
				items={items}
				fields={processedFields}
				emptyText={this.emptyText}
				scopedSlots={this.$scopedSlots}
				sortCompare={this.pseudoCompare}
			/>
		);
	},
	methods: {
		toString(v) {
			if (!v) {
				return "";
			}
			if (v instanceof Object) {
				return keys(v)
					.map(k => toString(v[k]))
					.join(" ");
			}
			return String(v);
		},
		pseudoCompare(a, b, key) {
			//Forced head always sorts first
			if (a.forceHead && !b.forceHead) {
				return 1;
			}
			if (!a.forceHead && b.forceHead) {
				return -1;
			}
			//Forced foot always sorts last
			if (a.forceFoot && !b.forceFoot) {
				return -1;
			}
			if (!a.forceFoot && b.forceFoot) {
				return 1;
			}
			if (typeof a[key] === "number" && typeof b[key] === "number") {
				// If both compared fields are native numbers
				return a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0;
			} else {
				// Stringify the field data and use String.localeCompare
				return this.toString(a[key]).localeCompare(
					this.toString(b[key])
				);
			}
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ReportTable.vue